'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentOney4XAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M59.183 19.6281C63.1384 19.6281 66.3703 22.8882 66.3946 26.8968C66.3946 27.2817 66.3628 27.8393 66.337 28.1173H54.6684C55.2624 30.8137 57.4312 32.007 59.2397 32.007C60.6639 32.007 62.1592 31.3668 62.9515 30.4167L62.9689 30.397H65.9186C65.9186 30.397 65.9118 30.4288 65.8807 30.4925C64.415 33.4927 61.3328 34.5503 59.133 34.5503C57.2064 34.5503 55.3948 33.7578 54.0221 32.3191C52.6736 30.8986 51.923 29.0363 51.923 27.0756C51.923 22.8996 55.1141 19.6281 59.183 19.6281ZM59.1602 22.1677C56.8393 22.1677 55.114 23.9322 54.7553 25.7376H63.5575C63.2034 23.9322 61.478 22.1677 59.1602 22.1677ZM39.7745 26.2869C39.7745 23.4943 41.1109 22.0828 43.7405 22.0828C46.3694 22.0828 47.6974 23.4943 47.6974 26.2869V34.5564H50.3952V26.0929C50.3793 24.6087 50.1084 23.5594 49.509 22.5745C48.7939 21.4684 47.0905 19.6077 43.7405 19.6077C40.3814 19.6077 38.6833 21.4684 37.9675 22.5745C37.3629 23.5594 37.1003 24.6087 37.0745 26.0929V34.5564H39.7745V26.2869ZM74.7397 33.5122L80.431 19.6098H77.6024L73.3345 30.0635L69.0764 19.6098H66.1108L71.9277 33.5152L69.7506 38.8549H72.5566L73.333 36.9526L74.7397 33.5122ZM23.2651 27.0945C23.2651 29.8523 25.427 32.0153 28.0824 32.0153C30.7196 32.0153 32.8921 29.8523 32.8921 27.0945C32.8921 24.3353 30.7196 22.1677 28.0824 22.1677C25.427 22.1677 23.2651 24.3353 23.2651 27.0945ZM20.6331 27.0921C20.6331 22.8941 23.9044 19.6098 28.0816 19.6098C32.2488 19.6098 35.5186 22.8941 35.5186 27.0921C35.5186 31.287 32.2488 34.5759 28.0816 34.5759C23.9044 34.5759 20.6331 31.287 20.6331 27.0921ZM14.3441 28.4895L14.9994 29.6524H16.4674L15.0985 27.6341L16.4424 25.6499H14.9744L14.3441 26.7795L13.7137 25.6499H12.2457L13.5979 27.6341L12.2207 29.6524H13.6895L14.3441 28.4895ZM11.2756 28.05H11.9801V26.9121H11.2756V25.3097H9.93998V26.9121H8.96154V23.8399H7.6176V28.05H9.93998V29.6524H11.2756V28.05ZM4.34479 27.081C4.34479 22.8944 7.60778 19.6177 11.7743 19.6177C15.931 19.6177 19.1932 22.8944 19.1932 27.081C19.1932 31.2654 15.931 34.5459 11.7743 34.5459C7.60778 34.5459 4.34479 31.2654 4.34479 27.081Z",
          fill: "#87BC2B"
        }
      )
    ]
  }
);
const VpPaymentOney4XAsset = forwardRef(PaymentOney4XAsset);

export { VpPaymentOney4XAsset as default };
